const getMediaUrl = () => import.meta.env.VITE_MEDIA_URL ?? "";

export const SetSrc = (url: string, type: "Full" | "Media" = "Media") => {
  if (!url) return "";

  // If the URL is already absolute (http/https/blob/data) or a local asset path, return as-is
  if (
    url.startsWith("http://") ||
    url.startsWith("https://") ||
    url.startsWith("blob:") ||
    url.startsWith("data:") ||
    url.startsWith("/")
  ) {
    return url;
  }

  const api =
    type === "Full" ? (import.meta.env.VITE_API_URL ?? "") : getMediaUrl();

  // Backend media paths are expected to be relative; prefix with media URL + /storage
  return `${api}/storage/${url}`;
};
